import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { referrerCodeStorage } from 'domains/landing-page/components/pflegia-friends/referrer-code.storage';
import { useCallback, useEffect } from 'react';

type Props = {
  isReferrerValid: boolean;
  referrerCode: string;
  source: string;
};

export default function useUpdatePflegiaFriendsStats({ isReferrerValid, referrerCode, source }: Props) {
  const [updatePflegiaFriendsStatistics] = useMutation(UPDATE_PFLEGIA_FRIENDS_STATISTICS);

  const checkForUpdatePflegiaFriendsStats = useCallback(async () => {
    if (!isReferrerValid) return null;
    const oldReferrarCode = referrerCodeStorage.getReferrerCode();

    if (oldReferrarCode !== referrerCode && source) {
      await updatePflegiaFriendsStatistics({ variables: { source } });
    }
  }, [isReferrerValid, referrerCode, source, updatePflegiaFriendsStatistics]);

  useEffect(() => {
    checkForUpdatePflegiaFriendsStats();
  }, [checkForUpdatePflegiaFriendsStats]);
}

const UPDATE_PFLEGIA_FRIENDS_STATISTICS = gql`
  mutation UpdatePflegiaFriendsStatistics($source: String!) {
    updatePflegiaFriendsStatistics(source: $source)
  }
`;
